const b = "react", I = "[Builder.io]: ", h = {
  log: (...t) => console.log(I, ...t),
  error: (...t) => console.error(I, ...t),
  warn: (...t) => console.warn(I, ...t),
  debug: (...t) => console.debug(I, ...t)
};
function c() {
  return typeof window != "undefined" && typeof document != "undefined";
}
const it = (t) => {
  const e = {};
  return t.forEach((n, r) => {
    e[r] = n;
  }), e;
}, K = (t) => t instanceof URLSearchParams ? it(t) : t, M = (t) => typeof t == "string" ? t : t instanceof URLSearchParams ? t.toString() : new URLSearchParams(t).toString();
function at() {
  return c() && window.self !== window.top;
}
function ct(t) {
  return at() && // accessing window.location.search is safe here because `isIframe()` is only `true` if we're in a browser.
  M(t || window.location.search).indexOf("builder.frameEditing=") !== -1;
}
const ut = () => {
  if (c()) {
    const t = new URL(location.href);
    return t.pathname === "" && (t.pathname = "/"), t;
  } else
    return console.warn("Cannot get location for tracking in non-browser environment"), null;
}, lt = () => typeof navigator == "object" && navigator.userAgent || "", dt = () => {
  const t = lt(), e = {
    Android() {
      return t.match(/Android/i);
    },
    BlackBerry() {
      return t.match(/BlackBerry/i);
    },
    iOS() {
      return t.match(/iPhone|iPod/i);
    },
    Opera() {
      return t.match(/Opera Mini/i);
    },
    Windows() {
      return t.match(/IEMobile/i) || t.match(/WPDesktop/i);
    },
    any() {
      return e.Android() || e.BlackBerry() || e.iOS() || e.Opera() || e.Windows() || b === "reactNative";
    }
  }, n = t.match(/Tablet|iPad/i), r = ut();
  return {
    urlPath: r == null ? void 0 : r.pathname,
    host: (r == null ? void 0 : r.host) || (r == null ? void 0 : r.hostname),
    device: n ? "tablet" : e.any() ? "mobile" : "desktop"
  };
}, y = (t) => t != null;
function te(t) {
  const e = t || (c() ? window.location.search : void 0);
  return e ? M(e).indexOf("builder.preview=") !== -1 : !1;
}
const ee = (t) => ({
  type: "builder.registerComponent",
  data: W(t)
}), ft = (t) => {
  const e = t.toString().trim(), n = /^[a-zA-Z0-9_]+\s*=>/i.test(e);
  return `return (${!e.startsWith("function") && !e.startsWith("async") && !e.startsWith("(") && !n ? "function " : ""}${e}).apply(this, arguments)`;
};
function W(t) {
  return JSON.parse(JSON.stringify(t, (e, n) => typeof n == "function" ? ft(n) : n));
}
const x = {};
function ne(t, e) {
  t === "plugin" && (e = W(e));
  let n = x[t];
  if (n || (n = x[t] = []), n.push(e), c()) {
    const r = {
      type: "builder.register",
      data: {
        type: t,
        info: e
      }
    };
    try {
      parent.postMessage(r, "*"), parent !== window && window.postMessage(r, "*");
    } catch (s) {
      console.debug("Could not postmessage", s);
    }
  }
}
function re(t) {
  var e;
  if (c()) {
    const n = JSON.parse(JSON.stringify(t));
    t.action && (n.action = t.action.toString()), (e = window.parent) == null || e.postMessage({
      type: "builder.registerAction",
      data: n
    }, "*");
  }
}
const _ = {};
function se(t) {
  if (c()) {
    Object.assign(_, t);
    const e = {
      type: "builder.settingsChange",
      data: _
    };
    parent.postMessage(e, "*");
  }
}
const L = "builder.", ht = "options.", j = (t) => {
  if (!t)
    return {};
  const e = K(t), n = {};
  return Object.keys(e).forEach((r) => {
    if (r.startsWith(L)) {
      const s = r.replace(L, "").replace(ht, "");
      n[s] = e[r];
    }
  }), n;
}, gt = () => {
  if (!c())
    return {};
  const t = new URLSearchParams(window.location.search);
  return j(t);
}, $ = "4.2.4", G = () => ({
  "X-Builder-SDK": b,
  "X-Builder-SDK-GEN": "2",
  "X-Builder-SDK-Version": $
}), pt = (t) => {
  if (t === "localhost" || t === "127.0.0.1")
    return t;
  const e = t.split(".");
  return e.length > 2 ? e.slice(1).join(".") : t;
}, U = ({
  name: t,
  canTrack: e
}) => {
  var n;
  try {
    return e ? (n = document.cookie.split("; ").find((r) => r.startsWith(`${t}=`))) == null ? void 0 : n.split("=")[1] : void 0;
  } catch (r) {
    h.warn("[COOKIE] GET error: ", (r == null ? void 0 : r.message) || r);
    return;
  }
}, J = async (t) => U(t), St = (t) => t.map(([e, n]) => n ? `${e}=${n}` : e).filter(y).join("; "), yt = [["secure", ""], ["SameSite", "None"]], bt = ({
  name: t,
  value: e,
  expires: n
}) => {
  const s = (c() ? location.protocol === "https:" : !0) ? yt : [[]], o = n ? [["expires", n.toUTCString()]] : [[]], i = [[t, e], ...o, ["path", "/"], ["domain", pt(window.location.hostname)], ...s];
  return St(i);
}, T = async ({
  name: t,
  value: e,
  expires: n,
  canTrack: r
}) => {
  try {
    if (!r)
      return;
    const s = bt({
      name: t,
      value: e,
      expires: n
    });
    document.cookie = s;
  } catch (s) {
    h.warn("[COOKIE] SET error: ", (s == null ? void 0 : s.message) || s);
  }
};
function mt() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
    const e = Math.random() * 16 | 0;
    return (t == "x" ? e : e & 3 | 8).toString(16);
  });
}
function z() {
  return mt().replace(/-/g, "");
}
const X = "builderSessionId", wt = async ({
  canTrack: t
}) => {
  if (!t)
    return;
  const e = await J({
    name: X,
    canTrack: t
  });
  if (y(e))
    return e;
  {
    const n = Et();
    return At({
      id: n,
      canTrack: t
    }), n;
  }
}, Et = () => z(), At = ({
  id: t,
  canTrack: e
}) => T({
  name: X,
  value: t,
  canTrack: e
}), H = () => c() && typeof localStorage != "undefined" ? localStorage : void 0, It = ({
  key: t,
  canTrack: e
}) => {
  var n;
  try {
    return e ? (n = H()) == null ? void 0 : n.getItem(t) : void 0;
  } catch (r) {
    console.debug("[LocalStorage] GET error: ", r);
    return;
  }
}, vt = ({
  key: t,
  canTrack: e,
  value: n
}) => {
  var r;
  try {
    e && ((r = H()) == null || r.setItem(t, n));
  } catch (s) {
    console.debug("[LocalStorage] SET error: ", s);
  }
}, Q = "builderVisitorId", kt = ({
  canTrack: t
}) => {
  if (!t)
    return;
  const e = It({
    key: Q,
    canTrack: t
  });
  if (y(e))
    return e;
  {
    const n = Ut();
    return Tt({
      id: n,
      canTrack: t
    }), n;
  }
}, Ut = () => z(), Tt = ({
  id: t,
  canTrack: e
}) => vt({
  key: Q,
  value: t,
  canTrack: e
});
function Ot(t) {
  var e;
  typeof process != "undefined" && ((e = process.env) != null && e.DEBUG) && String(process.env.DEBUG) == "true" && h.log(t);
}
const Pt = async ({
  canTrack: t
}) => {
  if (!t)
    return {
      visitorId: void 0,
      sessionId: void 0
    };
  const e = await wt({
    canTrack: t
  }), n = kt({
    canTrack: t
  });
  return {
    sessionId: e,
    visitorId: n
  };
}, Rt = async ({
  type: t,
  canTrack: e,
  apiKey: n,
  metadata: r,
  ...s
}) => ({
  type: t,
  data: {
    ...s,
    metadata: {
      url: location.href,
      ...r
    },
    ...await Pt({
      canTrack: e
    }),
    userAttributes: dt(),
    ownerId: n
  }
});
async function Ct({
  apiHost: t,
  ...e
}) {
  if (!e.apiKey) {
    h.error("Missing API key for track call. Please provide your API key.");
    return;
  }
  if (!e.canTrack || ct() || !(c() || b === "reactNative"))
    return;
  const r = `${t || "https://cdn.builder.io"}/api/v1/track`;
  return Ot(r), fetch(r, {
    method: "POST",
    body: JSON.stringify({
      events: [await Rt(e)]
    }),
    headers: {
      "content-type": "application/json",
      ...G()
    },
    mode: "cors"
  }).catch((s) => {
    console.error("Failed to track: ", s);
  });
}
const oe = (t) => Ct({
  ...t,
  canTrack: !0
}), Bt = ["*.beta.builder.io", "beta.builder.io", "builder.io", "localhost", "qa.builder.io"];
function Y(t, e) {
  if (!e.origin.startsWith("http") && !e.origin.startsWith("https"))
    return !1;
  const n = new URL(e.origin), r = n.hostname;
  return (t || Bt).findIndex((s) => s.startsWith("*.") ? r.endsWith(s.slice(1)) : s === r) > -1;
}
let N = !1;
const xt = (t) => {
  var e, n;
  N || (N = !0, c() && ((e = window.parent) == null || e.postMessage({
    type: "builder.sdkInfo",
    data: {
      target: b,
      version: $,
      supportsPatchUpdates: !1,
      // Supports builder-model="..." attribute which is needed to
      // scope our '+ add block' button styling
      supportsAddBlockScoping: !0,
      supportsCustomBreakpoints: !0,
      modelName: t.modelName,
      apiKey: t.apiKey,
      supportsXSmallBreakpoint: !0,
      blockLevelPersonalization: !0
    }
  }, "*"), (n = window.parent) == null || n.postMessage({
    type: "builder.updateContent",
    data: {
      options: t
    }
  }, "*"), window.addEventListener("message", (r) => {
    var o, i;
    if (!Y(t.trustedHosts, r))
      return;
    const {
      data: s
    } = r;
    if (s != null && s.type)
      switch (s.type) {
        case "builder.evaluate": {
          const u = s.data.text, l = s.data.arguments || [], S = s.data.id, m = new Function(u);
          let d, g = null;
          try {
            d = m.apply(null, l);
          } catch (p) {
            g = p;
          }
          g ? (o = window.parent) == null || o.postMessage({
            type: "builder.evaluateError",
            data: {
              id: S,
              error: g.message
            }
          }, "*") : d && typeof d.then == "function" ? d.then((p) => {
            var w;
            (w = window.parent) == null || w.postMessage({
              type: "builder.evaluateResult",
              data: {
                id: S,
                result: p
              }
            }, "*");
          }).catch(console.error) : (i = window.parent) == null || i.postMessage({
            type: "builder.evaluateResult",
            data: {
              result: d,
              id: S
            }
          }, "*");
          break;
        }
      }
  })));
}, _t = ({
  model: t,
  trustedHosts: e,
  callbacks: n
}) => (r) => {
  if (!Y(e, r))
    return;
  const {
    data: s
  } = r;
  if (s)
    switch (s.type) {
      case "builder.configureSdk": {
        n.configureSdk(s.data);
        break;
      }
      case "builder.triggerAnimation": {
        n.animation(s.data);
        break;
      }
      case "builder.resetState": {
        const o = s.data, i = o.model, u = o == null ? void 0 : o.state, l = o.editType;
        i === t && u && n.stateUpdate(u, l);
        break;
      }
      case "builder.contentUpdate": {
        const o = s.data, i = o.key || o.alias || o.entry || o.modelName, u = o.data, l = o.editType;
        i === t && n.contentUpdate(u, l);
        break;
      }
    }
}, ie = ({
  model: t,
  apiKey: e,
  callback: n,
  trustedHosts: r
}) => {
  if (!c)
    return h.warn("`subscribeToEditor` only works in the browser. It currently seems to be running on the server."), () => {
    };
  xt({
    modelName: t,
    apiKey: e
  });
  const s = _t({
    callbacks: {
      contentUpdate: n,
      animation: () => {
      },
      configureSdk: () => {
      },
      stateUpdate: () => {
      }
    },
    model: t,
    trustedHosts: r
  });
  return window.addEventListener("message", s), () => {
    window.removeEventListener("message", s);
  };
}, Lt = "builder.tests", O = (t) => `${Lt}.${t}`, Nt = ({
  contentId: t
}) => J({
  name: O(t),
  canTrack: !0
}), Vt = ({
  contentId: t
}) => U({
  name: O(t),
  canTrack: !0
}), Dt = ({
  contentId: t,
  value: e
}) => T({
  name: O(t),
  value: e,
  canTrack: !0
}), Z = (t) => y(t.id) && y(t.variations) && Object.keys(t.variations).length > 0, Ft = ({
  id: t,
  variations: e
}) => {
  var s;
  let n = 0;
  const r = Math.random();
  for (const o in e) {
    const i = (s = e[o]) == null ? void 0 : s.testRatio;
    if (n += i, r < n)
      return o;
  }
  return t;
}, q = (t) => {
  const e = Ft(t);
  return Dt({
    contentId: t.id,
    value: e
  }).catch((n) => {
    h.error("could not store A/B test variation: ", n);
  }), e;
}, tt = ({
  item: t,
  testGroupId: e
}) => {
  const n = t.variations[e];
  return e === t.id || // handle edge-case where `testGroupId` points to non-existing variation
  !n ? {
    testVariationId: t.id,
    testVariationName: "Default"
  } : {
    data: n.data,
    testVariationId: n.id,
    testVariationName: n.name || (n.id === t.id ? "Default" : "")
  };
}, ae = ({
  item: t,
  canTrack: e
}) => {
  if (!e)
    return t;
  if (!t)
    return;
  if (!Z(t))
    return t;
  const n = Vt({
    contentId: t.id
  }) || q({
    variations: t.variations,
    id: t.id
  }), r = tt({
    item: t,
    testGroupId: n
  });
  return {
    ...t,
    ...r
  };
}, Kt = async ({
  item: t,
  canTrack: e
}) => {
  if (!e || !Z(t))
    return t;
  const r = await Nt({
    contentId: t.id
  }) || q({
    variations: t.variations,
    id: t.id
  }), s = tt({
    item: t,
    testGroupId: r
  });
  return {
    ...t,
    ...s
  };
};
const V = "builder.userAttributes";
function D() {
  let t = !0;
  const e = /* @__PURE__ */ new Set();
  return {
    setUserAttributes(n) {
      if (!c())
        return;
      const r = {
        ...this.getUserAttributes(),
        ...n
      };
      T({
        name: V,
        value: JSON.stringify(r),
        canTrack: t
      }), e.forEach((s) => s(r));
    },
    getUserAttributes() {
      return c() ? JSON.parse(U({
        name: V,
        canTrack: t
      }) || "{}") : {};
    },
    subscribeOnUserAttributesChange(n, {
      fireImmediately: r
    } = {}) {
      return e.add(n), r && n(this.getUserAttributes()), function() {
        e.delete(n);
      };
    },
    setCanTrack(n) {
      t = n;
    }
  };
}
let v;
c() && b === "qwik" ? (window.__BUILDER_USER_ATTRIBUTES_SERVICE__ || (window.__BUILDER_USER_ATTRIBUTES_SERVICE__ = D()), v = window.__BUILDER_USER_ATTRIBUTES_SERVICE__) : v = D();
const et = v, ce = (t) => {
  et.setUserAttributes(t);
}, Mt = (t) => {
  const e = y(t) ? t : !0;
  return et.setCanTrack(e), e;
};
function Wt() {
  return typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : globalThis;
}
function jt() {
  const t = Wt().fetch;
  if (typeof t == "undefined")
    throw console.warn(`Builder SDK could not find a global fetch function. Make sure you have a polyfill for fetch in your project. 
      For more information, read https://github.com/BuilderIO/this-package-uses-fetch`), new Error("Builder SDK could not find a global `fetch` function");
  return t;
}
const $t = jt();
function k(t, e = null, n = ".") {
  return Object.keys(t).reduce((r, s) => {
    const o = t[s], i = [e, s].filter(Boolean).join(n);
    return [typeof o == "object", o !== null, !(Array.isArray(o) && o.length === 0)].every(Boolean) ? {
      ...r,
      ...k(o, i, n)
    } : {
      ...r,
      [i]: o
    };
  }, {});
}
function nt(t, e, n = {}) {
  for (const r in t) {
    const s = t[r], o = e ? e + "." + r : r;
    s && typeof s == "object" && !Array.isArray(s) && !Object.keys(s).find((i) => i.startsWith("$")) ? nt(s, o, n) : n[o] = s;
  }
  return n;
}
function Gt(t) {
  const e = {};
  for (const n in t) {
    const r = n.split(".");
    let s = e;
    for (let o = 0; o < r.length; o++) {
      const i = r[o];
      o === r.length - 1 ? s[i] = t[n] : (s[i] = s[i] || {}, s = s[i]);
    }
  }
  return e;
}
const Jt = "v3", F = (t) => typeof t == "number" && !isNaN(t) && t >= 0, P = (t) => {
  const {
    limit: e = 30,
    userAttributes: n,
    query: r,
    model: s,
    apiKey: o,
    enrich: i,
    locale: u,
    apiVersion: l = Jt,
    fields: S,
    omit: m,
    offset: d,
    cacheSeconds: g,
    staleCacheSeconds: p,
    sort: w,
    includeUnpublished: R,
    apiHost: rt
  } = t;
  if (!o)
    throw new Error("Missing API key");
  if (!["v3"].includes(l))
    throw new Error(`Invalid apiVersion: expected 'v3', received '${l}'`);
  const st = e !== 1, ot = rt || "https://cdn.builder.io", a = new URL(`${ot}/api/${l}/content/${s}`);
  a.searchParams.set("apiKey", o), a.searchParams.set("limit", String(e)), a.searchParams.set("noTraverse", String(st)), a.searchParams.set("includeRefs", String(!0)), u && a.searchParams.set("locale", u);
  let A = n || {};
  if (i && a.searchParams.set("enrich", String(i)), a.searchParams.set("omit", m != null ? m : "meta.componentsUsed"), S && a.searchParams.set("fields", S), Number.isFinite(d) && d > -1 && a.searchParams.set("offset", String(Math.floor(d))), typeof R == "boolean" && a.searchParams.set("includeUnpublished", String(R)), g && F(g) && a.searchParams.set("cacheSeconds", String(g)), p && F(p) && a.searchParams.set("staleCacheSeconds", String(p)), w) {
    const f = k({
      sort: w
    });
    for (const E in f)
      a.searchParams.set(E, JSON.stringify(f[E]));
  }
  const C = {
    ...gt(),
    ...K(t.options || {})
  };
  A = {
    ...A,
    ...Xt(C)
  };
  const B = k(C);
  for (const f in B)
    a.searchParams.set(f, String(B[f]));
  if (Object.keys(A).length > 0 && a.searchParams.set("userAttributes", JSON.stringify(A)), r) {
    const f = nt({
      query: r
    });
    for (const E in f)
      a.searchParams.set(E, JSON.stringify(f[E]));
  }
  return a;
}, zt = (t) => {
  const e = {};
  for (const n in t)
    n.startsWith("userAttributes.") && (e[n] = t[n], delete t[n]);
  return e;
}, Xt = (t) => {
  if (c() && t.preview === "BUILDER_STUDIO") {
    t["userAttributes.urlPath"] = window.location.pathname, t["userAttributes.host"] = window.location.host;
    const e = zt(t), {
      userAttributes: n
    } = Gt(e);
    return n;
  }
  return {};
}, Ht = (t) => "results" in t;
async function Qt(t) {
  var r;
  const e = t.locale || ((r = t.userAttributes) == null ? void 0 : r.locale);
  e && (t.locale = e, t.userAttributes = {
    locale: e,
    ...t.userAttributes
  });
  const n = await qt({
    ...t,
    limit: 1
  });
  return n && n[0] || null;
}
const Yt = async (t) => {
  var i, u;
  const e = P(t), n = (i = t.fetch) != null ? i : $t, r = {
    ...t.fetchOptions,
    headers: {
      ...(u = t.fetchOptions) == null ? void 0 : u.headers,
      ...G()
    }
  };
  return await (await n(e.href, r)).json();
}, Zt = async (t, e, n = P(t)) => {
  const r = Mt(t.canTrack);
  if (n.search.includes("preview="), !r || !(c() || b === "reactNative"))
    return e.results;
  try {
    const s = [];
    for (const o of e.results)
      s.push(await Kt({
        item: o,
        canTrack: r
      }));
    e.results = s;
  } catch (s) {
    h.error("Could not process A/B tests. ", s);
  }
  return e.results;
};
async function qt(t) {
  const e = P(t), n = await Yt(t);
  if (!Ht(n))
    throw h.error("Error fetching data. ", {
      url: e,
      content: n,
      options: t
    }), n;
  return Zt(t, n);
}
const ue = async (t) => {
  var r, s, o;
  const e = t.path || ((r = t.url) == null ? void 0 : r.pathname) || ((s = t.userAttributes) == null ? void 0 : s.urlPath), n = {
    ...t,
    apiKey: t.apiKey,
    model: t.model || "page",
    userAttributes: {
      ...t.userAttributes,
      ...e ? {
        urlPath: e
      } : {}
    },
    options: j(t.searchParams || ((o = t.url) == null ? void 0 : o.searchParams) || t.options)
  };
  return {
    apiKey: n.apiKey,
    model: n.model,
    content: await Qt(n)
  };
};
export {
  b as TARGET,
  Zt as _processContentResult,
  Ct as _track,
  y as checkIsDefined,
  _t as createEditorListener,
  ee as createRegisterComponentMessage,
  ue as fetchBuilderProps,
  qt as fetchEntries,
  Qt as fetchOneEntry,
  j as getBuilderSearchParams,
  U as getCookieSync,
  Mt as getDefaultCanTrack,
  dt as getUserAttributes,
  ae as handleABTestingSync,
  c as isBrowser,
  ct as isEditing,
  te as isPreviewing,
  Ot as logFetch,
  h as logger,
  ne as register,
  re as registerAction,
  W as serializeIncludingFunctions,
  ce as setClientUserAttributes,
  se as setEditorSettings,
  xt as setupBrowserForEditing,
  ie as subscribeToEditor,
  oe as track,
  et as userAttributesService
};
